export default "__VITE_ASSET__BsmyfZGs__"